import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import '../styles.scss';

const tabs = [
    { name: 'info', title: 'Account' },
    // { name: 'bethistory', title: 'Bet History' },
];

const isTabActive = tabName =>
    match => match && match.path.split('/').pop() === tabName;

class Tabs extends Component {
    constructor(props) {
        super(props);
        this.tabs = [...tabs];
    }

    render() {
        return (
            <div className="bs-tabs bs-account__tabs">
                {
                    this.tabs.map(({ name, title }) => (
                        <NavLink
                            isActive={isTabActive(name)}
                            activeClassName="bs-tabs__tab_active"
                            className="bs-tabs__tab"
                            to={{
                                pathname: `/${this.props.feed}/account/${name}`,
                                state: {
                                    enableAnimation: false,
                                },
                            }}
                            key={name}
                        >
                            <span>{title}</span>
                        </NavLink>))
                }
            </div>
        );
    }
}

Tabs.propTypes = {
    feed: PropTypes.string.isRequired,
};

export default Tabs;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/Tabs.jsx